export enum IconSizes {
  small = 'small',
  default = 'default',
  large = 'large',
}
